import { render, staticRenderFns } from "./ColorSelector.vue?vue&type=template&id=2a94ad06&scoped=true"
import script from "./ColorSelector.vue?vue&type=script&lang=ts"
export * from "./ColorSelector.vue?vue&type=script&lang=ts"
import style0 from "./ColorSelector.vue?vue&type=style&index=0&id=2a94ad06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94ad06",
  null
  
)

export default component.exports